import React, {
    memo,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import { connect } from 'react-redux';
import { ProductCardLink, ProductCardLoader } from './components/productCard';
import { useLocation, useParams } from 'react-router';
import { ShopSelectType } from 'app/modules/shop/actions/getList';
import { map } from 'underscore';
import { Button, Col, Result, Row } from 'antd';
import { findType } from 'app/functions/breadcrumbs';
import { Breadcrumbs } from 'app/shared/breadcrumbs/breadcrumbs';
import { Category } from 'app/components/content/category';
import { openProductModal } from './actions/setModal';
import { fetchOrderStore } from './actions/getProduct';
import { useMediaQuery } from 'react-responsive';
import { breakPoints } from 'app/constants';
import { Pagination } from 'app/shared/pagination/pagination';
import { useGetActiveTypesQuery, useLazyGetProductsQuery } from 'app/api';
import classNames from 'classnames';
import { ScrollToHashElement } from 'app/components/ScrollToHashElement';
import { useFirstInViewport } from 'app/hooks/useFirstInViewport';

const Shop = ({ typeID, point, dispatch, openModalProduct, productView }) => {
    const listView = productView === 'list';
    const ref = useRef();
    const inView = useFirstInViewport(ref, {
        threshold: 0.25,
    });
    const [
        triggerProduct,
        {
            isLoading: productsResponseIsLoading,
            isFetching: productsResponseIsFetching,
            isError,
            data: productsResponse,
        },
    ] = useLazyGetProductsQuery();
    const params = useParams();
    const { productID, categoryID: paramsID } = params;
    const categoryID = typeID || paramsID;
    const [products, setProducts] = useState([]);
    const location = useLocation();
    const [page, setPage] = useState(1);

    const isMobile = !useMediaQuery({
        query: breakPoints.xsMobile,
    });

    const { data: typesResponse, isLoading: typesResponseIsLoading } =
        useGetActiveTypesQuery({ point: point?.id }, { skip: !point?.id });

    const type = useMemo(() => {
        if (typesResponseIsLoading) return {};
        return findType(
            typesResponse?.data_response?.types,
            Number(categoryID)
        );
    }, [categoryID, typesResponse]);

    useEffect(() => {
        setProducts([]);
        /* document.body.scrollTo(0, 0);*/
        if (inView) {
            fetchProducts(page, (response) => {
                setProducts(response?.data);
                if (location.state?.withoutModal) return;
                if (productID) {
                    dispatch(
                        fetchOrderStore(
                            {
                                id: productID,
                                point: point.id,
                            },
                            (response) => {
                                if (response.product)
                                    openModalProduct(response.product);
                            }
                        )
                    );
                }
            });
        }
    }, [categoryID, productID, type, inView]);

    function fetchProducts(page, valid) {
        if (categoryID && type) {
            if (!typeID) dispatch(ShopSelectType(categoryID, type?.children));
            triggerProduct({
                type_id: categoryID,
                point: point.id,
                page,
            })
                .unwrap()
                .then((response) => valid(response?.data_response));
        }
    }

    const onProductClick = useCallback((e, to) => {
        e.preventDefault();
        window.history.replaceState(null, null, to);
    }, []);

    function onPaginationChange(page) {
        fetchProducts(page, (response) => {
            setProducts(response?.data);
            setPage(page);
            document.body.scrollTo(0, 0);
        });
    }

    function loadMoreProducts() {
        const newPage = page + 1;
        fetchProducts(newPage, (response) => {
            setProducts((prev) => [...prev, ...(response?.data || [])]);
            setPage(newPage);
        });
    }
    function onError() {
        window.location?.reload();
    }
    const config = productsResponse?.data_response;
    const areProductsEmpty =
        !productsResponseIsFetching &&
        !productsResponseIsLoading &&
        !config?.count;
    const areProductsVisible = typeID || !areProductsEmpty;
    if (isError)
        return (
            <Result
                status="500"
                title="500"
                subTitle="Извините, произошла ошибка на сервере."
                extra={
                    <Button onClick={onError} type="primary">
                        Обновить страницу
                    </Button>
                }
            />
        );

    const hasName = type?.name && productsResponse?.data_response?.data?.length;
    const hasCategories = type?.children?.length && (typeID || !listView);
    const sectionWidthCondition =
        hasName || hasCategories || areProductsVisible;
    return (
        <div className="shop-wrapper">
            {!type ? (
                <div className={'text-center'}>Категория не найдена!</div>
            ) : (
                <ScrollToHashElement>
                    <div
                        id={typeID}
                        className="products-wrapper"
                        style={!sectionWidthCondition ? { padding: 0 } : {}}
                    >
                        <div
                            style={{
                                width: '100%',
                                ...(sectionWidthCondition
                                    ? { minHeight: 250 }
                                    : {}),
                            }}
                            ref={ref}
                        >
                            {typeID ? null : (
                                <div className={'shop-container'}>
                                    <Breadcrumbs
                                        typeId={categoryID}
                                        className={'my-2'}
                                    />
                                </div>
                            )}

                            {hasName ? (
                                <div
                                    className={classNames(
                                        'product-type-header shop-container',
                                        {
                                            'product-type-header__parent':
                                                !typeID,
                                        }
                                    )}
                                >
                                    {type.name}
                                </div>
                            ) : null}
                            {hasCategories ? (
                                <div className={'shop-container mb-4'}>
                                    <div className={'shop-types my-2'}>
                                        {map(type?.children, ({ id, name }) => {
                                            return (
                                                <Category
                                                    key={id}
                                                    title={name}
                                                    id={id}
                                                    active
                                                />
                                            );
                                        })}
                                    </div>
                                </div>
                            ) : null}
                            {areProductsVisible ? (
                                <>
                                    {areProductsEmpty ? null : (
                                        <div
                                            className={'product-card__wrapper'}
                                        >
                                            <Products
                                                isMobile={isMobile}
                                                products={products}
                                                onProductClick={onProductClick}
                                                showEmpty={areProductsEmpty}
                                                showSkeletons={
                                                    productsResponseIsFetching
                                                }
                                            />
                                        </div>
                                    )}
                                    {!config?.count ||
                                    config?.page_max < 2 ? null : (
                                        <div className={'products-pagination'}>
                                            {page < config?.page_max ? (
                                                <Button
                                                    type={'primary'}
                                                    style={{ width: '100%' }}
                                                    onClick={loadMoreProducts}
                                                    loading={
                                                        productsResponseIsFetching
                                                    }
                                                >
                                                    Показать еще
                                                </Button>
                                            ) : null}
                                            <Pagination
                                                disabled={
                                                    productsResponseIsFetching
                                                }
                                                onChange={onPaginationChange}
                                                current={page}
                                                total={config?.count}
                                                pageSize={config?.row}
                                            />
                                        </div>
                                    )}
                                </>
                            ) : null}
                        </div>
                    </div>
                </ScrollToHashElement>
            )}
            {typeID || !listView
                ? null
                : map(type?.children, ({ id }) => {
                      return <ShopLink key={id} typeID={id} />;
                  })}
        </div>
    );
};

const Products = memo(
    ({ products, showSkeletons, onProductClick, isMobile }) => {
        return (
            <>
                <Row
                    gutter={[30, 30]}
                    style={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                >
                    {showSkeletons
                        ? Array.from({ length: 8 }).map((_, index) => {
                              return (
                                  <Col
                                      span={8}
                                      {...productCardClassNames}
                                      key={index}
                                  >
                                      <ProductCardLoader
                                          height={isMobile ? 270 : 320}
                                      />
                                  </Col>
                              );
                          })
                        : map(products, (item) => {
                              return (
                                  <Col
                                      span={8}
                                      {...productCardClassNames}
                                      key={item.id}
                                  >
                                      <ProductCardLink
                                          rowView={isMobile}
                                          onClick={onProductClick}
                                          product={item}
                                      />
                                  </Col>
                              );
                          })}
                </Row>
            </>
        );
    }
);
export const productCardClassNames = {
    xs: 24,
    sm: 12,
    md: 8,
    lg: 6,
    className: 'product-card-container',
};
const mapStateToProps = (state) => {
    return {
        route: state.appState.route,
        productView: state.appState.setting?.content?.products?.productView,
        currency: state.pointsState.currency,
        point: state.shopState.order.point,
        products: state.shopState.shopCase.products,
        types: state.shopState.types,
        active_type: state.shopState.active_type,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        openModalProduct: (product) => {
            dispatch(openProductModal(product));
        },
    };
};

const ShopLink = connect(mapStateToProps, mapDispatchToProps)(Shop);

export { ShopLink };
